/**
 * CSV Template utilities for roster upload
 */

import { CSV_HEADERS, DEFAULT_TEMPLATE_FILENAME } from './constants';

/**
 * Generates CSV template content with headers only
 * @returns {string} CSV content with headers
 */
export const generateRosterTemplate = () => {
  return `${CSV_HEADERS.join(',')}\n`;
};

/**
 * Downloads CSV template file
 * @param {string} [filename] - Filename for download (defaults to DEFAULT_TEMPLATE_FILENAME)
 */
export const downloadRosterTemplate = (
  filename = DEFAULT_TEMPLATE_FILENAME,
) => {
  try {
    const csvContent = generateRosterTemplate();
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error downloading CSV template:', error);
  }
};
